export default __webpack_public_path__ + "static/media/Home-foto-header-sports-Tower-viajes-desk@2x.fe7b88b3.jpg";